export default __webpack_public_path__ + "static/media/team-cathy.f94b5c21.jpg";